import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="产品类型">{data.mon_type}</Description>
          <Description term="服务区域">{data.mon_area}</Description>
          <Description term="服务期限">{data.mom_time}</Description>
        </Row>
        <Row>
          <Description term="单价">{data.mom_unit}</Description>
          <Description term="总金额">{data.mom_money}</Description>
          <Description term="总金额大写">{data.mom_name}</Description>
        </Row>
        <Row>
          <Description term="信息详情">{data.mom_market}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProMom.js